const t = "adyen-pe-payouts-table", e = `${t}__net-payout`;
export {
  t as BASE_CLASS,
  e as NET_PAYOUT_CLASS
};
